import type { ActionMenuItemType } from "./ActionMenu";

export function filterActionMenuItems(
  items: ActionMenuItemType[],
  query: string,
): ActionMenuItemType[] {
  const needle = query.trim().toLowerCase();

  if (!needle) {
    return items;
  }

  return items.filter(
    (item) => !item.isDivider && !item.isTitle && (item.label ?? "").toLowerCase().includes(needle),
  );
}
